<template lang="pug" src="./custom-welch-consultation.pug"></template>

<script>
export default {
  props: ['props'],
  methods: {
    activate () {
      if (this.$store.state.showModal) {
        this.$store.dispatch('VIEW_SHOWMODAL', false)
      }
      this.$store.dispatch('VIEW_SHOWMODAL', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-welch-consultation.vue?4a766647